define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 348
// module chunks = 1